import { Component, Input, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';
import { LineChartDataset } from '../models';

@Component({
    selector: 'app-stat-linechart',
    templateUrl: './stat-linechart.component.html',
    styleUrls: ['./stat-linechart.component.scss'],
    standalone: false
})
export class StatLinechartComponent implements OnInit {
  @Input() chartData?: LineChartDataset[] = [];
  @Input() titleArray?: string[];
  @Input() showTooltip?: boolean = false;

  options!: EChartsOption;

  ngOnInit(): void {
    this.options = {
      legend: {},
      xAxis: {
        type: 'category',
        data: this.titleArray,
      },
      yAxis: {
        type: 'value',
      },
      series: this.chartData as EChartsOption['series'],
    };

    if (this.showTooltip) {
      this.options = { ...this.options, tooltip: {} };
    }
  }
}
